<template>
    <fieldset
        :id="id"
    >
        <legend
            :id="`${id}_heading`"
            class="lni-u-heading--2 lni-u-mb2"
        >
            {{ getData('contact.heading') }}
        </legend>
        <div class="lni-u-full-width lni-u-flex lni-u-flex-wrap lni-u-mv1">
            <lni-input-text
                :id="`${id}_first-name`"
                class="lni-u-mr1"
                :filled="true"
                :required="true"
            />
            <lni-input-text
                :id="`${id}_last-name`"
                :filled="true"
                :required="true"
            />
        </div>
        <div class="lni-u-full-width lni-u-flex lni-u-flex-wrap">
            <lni-input-phone
                :id="`${id}_phone-number`"
                class="lni-u-mt1 lni-u-mr1"
                :isFieldset="false"
                :filled="true"
                :hasExtension="false"
                :required="true"
            />
            <lni-input-email
                :id="`${id}_email-address`"
                :filled="true"
                :required="true"
                :minlength="10"
                :maxlength="50"
            />
        </div>
        <lni-input-address
            :id="`${id}_address`"
            class="lni-u-mb1"
            filled="true"
            :hasInlineMessages="false"
            :countyOptions="getData('counties')"
        />
        <div class="lni-u-form-width--base">
            <lni-input-text
                :id="`${id}_position-title`"
                class="lni-u-mb1 lni-u-mt0"
                :filled="true"
                :fullWidth="true"
            />
            <lni-select
                :id="`${id}_preferred-language`"
                class="lni-u-mb3 lni-u-full-width"
                :filled="true"
                :required="true"
            />
        </div>
    </fieldset>
</template>

<script>
export default {
    name: 'LniRetaliationContact',
    methods: {
        getData(name) {
            return this.$store.getters['appState/data'] ? this.$store.getters['appState/data'](name) : '';
        },
    },
};
</script>